import { PRIVATE_FETCH_OPTIONS, privateFetch, readPrivacyResponse } from './privateTransport';

let session = null;
let pending = null;
let generation = 0;
const listeners = new Set();
export const getFeatureSession = () => session;
export function clearFeatureSession() {
  generation++;
  pending?.controller.abort();
  pending = null;
  session = null;
  listeners.forEach(fn => fn());
}
export const onSessionChange = fn => { listeners.add(fn); return () => listeners.delete(fn); };
export async function ensureFeatureSession(authority) {
  if (session && session.authority === authority && Date.parse(session.expiresAt) > Date.now()) return session;
  if(session && session.authority !== authority) throw new Error('Feature session authority changed; reload before continuing');
  if(session) clearFeatureSession(); // Expiry invalidates every local permission.
  if (pending) {
    if(pending.authority !== authority) throw new Error('Feature session authority mismatch');
    return pending.promise;
  }
  const requestGeneration = generation;
  const controller = new AbortController();
  const promise = (async () => {
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`${authority}/api/privacy/session`, { ...PRIVATE_FETCH_OPTIONS, method: 'POST', signal:controller.signal, headers: {'Content-Type':'application/json'}, body: '{}' });
      const data = await readPrivacyResponse(response);
      if (requestGeneration !== generation) throw new Error('Feature session was cleared');
      if (!response.ok || typeof data.token !== 'string' || !data.token || typeof data.recoverySecret !== 'string' || !data.recoverySecret || !(Date.parse(data.expiresAt) > Date.now())) throw new Error('Unable to start this feature');
      session = {...data, authority};
      listeners.forEach(fn => fn());
      return session;
    } finally { clearTimeout(timer); }
  })();
  pending = {authority,promise,controller};
  try { return await promise; } finally { if (pending?.promise === promise) pending = null; }
}
export async function featureRequest(authority, path, init = {}) {
  if (init.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  if(/^\/api\/privacy\/(?:export|delete|delete-key)\/?$/.test(path)&&(!session||Date.parse(session.expiresAt)<=Date.now()))throw new Error('Use your Data Key to manage the original session. No replacement session was created.');
  const current = await ensureFeatureSession(authority);
  if (init.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  if (current !== session) throw new Error('Feature session was cleared');
  const headers = new Headers(init.headers || {});
  headers.set('X-Privacy-Session',current.token);
  const response = await privateFetch(`${authority}${path}`,{...init,headers},path.startsWith('/api/privacy/')?15000:90000);
  if(response.status === 401 && current === session) clearFeatureSession();
  return response;
}
